<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="wccard mb-1 d-flex justify-content-between align-items-center talenpool-sticky-header">
    <div class="d-flex align-items-center">
        <span class="py-2 f-14 font-weight-500 pointer pl-3 pr-6 mr-2" (click)="onTabChange('quicksearch')"
            [ngClass]="{'isActive': isQuickSearch}">
            Quick Search
        </span>
        <span class="py-2 f-14 font-weight-500 pointer px-8" (click)="onTabChange('advancedsearch')"
            [ngClass]="{'isActive': isAdvanceSearch}">
            Advanced Search
        </span>
        <span class="py-2 f-14 font-weight-500 pointer px-8 ai-active" (click)="onTabChange('similarcandidate')"
            [ngClass]="{'isActive': isSimilarCandidate}">
            Similar Candidates <i class="fa-solid fa-wand-magic-sparkles"></i>
        </span>
        <span class="py-2 f-14 font-weight-500 pointer px-8 ai-active" [ngClass]="{'isActive': isJdSearch}" (click)="onTabChange('jdsearch')" >
          Job Description <i class="fa-solid fa-wand-magic-sparkles"></i>
        </span>
    </div>
    <!-- <span class="dropdown ats-dropBtn" *ngIf="isQuickSearch || isAdvanceSearch">
      <button data-testid="auto-app-person-search-button-1" class=" dropdown-toggle text-webbtree-green" type="button" id="userDropdownButton" (click)="changeContinent()"
        appDropdownToggle aria-haspopup="true" aria-expanded="false"><i class="fas fa-earth mr-1"></i><span class="text-capitalize mr-1">{{showregion == 'asia' ? 'Asia': showregion == 'africa'? 'Africa': showregion == 'north america' ? 'North America': showregion == 'oceania' ? 'Oceania': showregion == 'south america' ? 'South America': 'Europe'}}</span> <i class="fas fa-chevron-down f-14"></i>
      </button>
      <app-continent-selector
          [parentRegion]="null"
          class="dropdown-menu"
          aria-labelledby="userDropdownButton"
      ></app-continent-selector>
    </span> -->
</div>

<!-- Quick search component -->
<!-- <div *ngIf="isQuickSearch">
  <app-quick-search></app-quick-search>
</div>

<div *ngIf="isAdvanceSearch">
<app-advance-search (dataEvent)="receiveData($event)" [events]="regionEvent.asObservable()"></app-advance-search>
</div>

<div *ngIf="isSimilarCandidate" class="h100vh">
  <app-similar-candidates></app-similar-candidates>
</div>

<div *ngIf="isJdSearch" style="margin-top: -15px;">
  <app-jd-search></app-jd-search>
</div> -->

<div>
  <router-outlet></router-outlet>
</div>


<ng-template #noCreditsJDParse class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-person-search-button-2" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../../assets/images/wallet.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">Apologies, but you have utilized all your credits</p>
          <p class="">To add more credits and upgrade your account.</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-person-search-button-3" class="btn-trms-medium m-auto" (click)="route2pricing()">Upgrade plan</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #historymodal class="modal">
  <div class="modal-content">
    <div class="modal-body px-3 pb-6 pt-3">
      <div class="d-flex justify-content-between mb-3">
        <div>
          <span class="font-weight-600">
            Search History
          </span>

        </div>
        <span class="text-bluex pointer">
          <i class="far fa-times f-16" (click)="modalService.dismissAll()"> </i>
        </span>
      </div>
      <div class="scroll-widget" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
        [scrollWindow]="false" (scrolled)="gethistory('pagination')">
        <div *ngFor="let history of searchToolboxHistory; index as i" class="row mx-0 mb-3px">
          <div class="col bb-3px py-3" style="border-top: 1px solid rgba(0, 0, 0, 0.1);">
            <div class="row">
              <div class="col d-flex justify-content-between mb-0 px-0">
                <a data-testid="auto-app-person-search-a-1" class="gray-text pointer collapsed font-weight-normal d-flex justify-content-between w-100"
                  data-bs-toggle="collapse" href="#collapseExample1{{i}}" role="button" aria-expanded="false"
                  aria-controls="collapseExample1" [ngClass]="{'showdhidearrow':!history.booleanquery}">
                  <div class="">
                    <p class="f-14 font-weight-500 text-black mb-0 text-capitalize">{{getHistoryHeadline(history)}}</p>
                  </div>
                  <div *ngIf="history.booleanquery">
                    <div class="col d-flex justify-content-between">
                      <p class="f-10 text-9696 mr-2 mt-1 mb-0" style="width: 105px;">{{formatDate(history?.updatedon)}}</p>
                      <i class="far fa-repeat-alt f-16 text-bluex" (click)="repeatSearch(history)"></i>
                    </div>
                  </div>
                  <div *ngIf="!history.booleanquery">
                    <div class="col d-flex justify-content-between">
                      <p class="f-10 text-9696 mr-2 mt-1 mb-0" style="width: 105px;">{{formatDate(history?.updatedon)}}</p>
                      <i class="far fa-repeat-alt f-16 text-bluex mr-2" (click)="repeatSearch(history)"></i>
                      <i class="far fa-chevron-down f-16 text-bluex"></i>
                      <i class="far fa-chevron-up f-16 text-bluex"></i>
                    </div>
                  </div>
                </a>
              </div>
            </div>

          </div>
          <div class="collapse px-3 w-100 mt-3px row mb-3" id="collapseExample1{{i}}" *ngIf="!history.booleanquery">
            <div class="row w-100">
              <div class="col-md-12" *ngIf="history?.booleanquery">
                <p class="mb-0">
                  {{history?.booleanquery}}
                </p>
              </div>
              <div class="col-md-6" *ngIf="history?.jobtitles">
                <p class="text-9696 mb-1"> Job Title </p>
                <p class="mb-0">
                  {{history?.jobtitles}}
                </p>
              </div>
              <div class="col-md-6" *ngIf="history?.mandatoryskills">
                <p class="text-9696 mb-1"> Mandatory Skills </p>
                <p class="mb-0">
                  {{history?.mandatoryskills}}
                </p>
              </div>
              <div class="col-md-6" *ngIf="history?.preferredskills">
                <p class="text-9696 mb-1"> Preferred Skills </p>
                <p class="mb-0">
                  {{history?.preferredskills}}
                </p>
              </div>
              <div class="col-md-6" *ngIf="history?.locations">
                <p class="text-9696 mb-1"> Location </p>
                <p class="mb-0">
                  {{history?.locations}}
                </p>
              </div>
            </div>
            <!-- <hr class="my-2"> -->
          </div>
        </div>
        <!-- <hr class="my-3"> -->
      </div>

    </div>
  </div>
</ng-template>
